<template>
	<div class="Meinungen">
		<div class="container">
			<h1>{{ $t('navigationMeinungen.title') }}</h1>
			<div class="row align-items-center">
				<div class="py-5 col-9">
					<div class="mb-5">
						{{ $t('navigationMeinungen.description') }}
					</div>

					<div class="mb-5">
						<div class="UnterUeberschrift">
							{{ $t('navigationMeinungen.opinion1.name') }}
						</div>
						<div>
							{{ $t('navigationMeinungen.opinion1.description.absatz1') }}
						</div>
						<div>
							{{ $t('navigationMeinungen.opinion1.description.absatz2') }}
						</div>
						<div class="mt-4">
							{{ $t('navigationMeinungen.opinion1.opinion') }}
						</div>
					</div>

					<div class="mb-5">
						<div class="UnterUeberschrift">
							{{ $t('navigationMeinungen.opinion2.name') }}
						</div>
						<div>
							{{ $t('navigationMeinungen.opinion2.description.absatz1') }}
						</div>
						<div class="mt-4">
							{{ $t('navigationMeinungen.opinion2.opinion') }}
						</div>
					</div>

					<div class="mb-5">
						<div class="UnterUeberschrift">
							{{ $t('navigationMeinungen.opinion3.name') }}
						</div>
						<div>
							{{ $t('navigationMeinungen.opinion3.description.absatz1') }}
						</div>
						<div>
							{{ $t('navigationMeinungen.opinion3.description.absatz2') }}
						</div>
						<div class="mt-4">
							{{ $t('navigationMeinungen.opinion3.opinion') }}
						</div>
					</div>

					<div class="mb-5">
						<div class="UnterUeberschrift">
							{{ $t('navigationMeinungen.opinion4.name') }}
						</div>
						<div>
							{{ $t('navigationMeinungen.opinion4.description.absatz1') }}
						</div>
						<div class="mt-4">
							{{ $t('navigationMeinungen.opinion4.opinion') }}
						</div>
					</div>

					<div class="mb-5">
						<div class="UnterUeberschrift">
							{{ $t('navigationMeinungen.opinion5.name') }}
						</div>
						<div>
							{{ $t('navigationMeinungen.opinion5.description.absatz1') }}
						</div>
						<div class="mt-4">
							{{ $t('navigationMeinungen.opinion5.opinion') }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Meinungen',
	i18n: {
		messages: {
			de: require('@/i18n/de/de_meinungen.json'),
			en: require('@/i18n/en/eng_meinungen.json')
		}
	}
}
</script>
